// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1plRR","rootMobile":"styles_rootMobile__Z4asu"};